import Vue from 'vue'
import Router from 'vue-router'
import Test from '@/components/Test'
import Login from '@/pages/login/login'
import Home from '@/pages/home/home'
import Charter from '@/pages/charter/charter'
import CharterDetails from '@/pages/charterDetails/charterDetails'
import Offer from '@/pages/offer/offer'
import Quotation from '@/pages/quotation/quotation'
import Information from '@/pages/information/information'
import Informationcharter from '@/pages/informationcharter/informationcharter'
import informationDetails from '@/pages/informationDetails/informationDetails'
import Join from '@/pages/join/join'
import About from '@/pages/about/about'
import HelpCenter from '@/pages/helpCenter/helpCenter'
import FeedBack from '@/pages/feedBack/feedBack'
import CustomTrips from '@/pages/customTrips/customTrips'

import Persondata from '@/pages/persondata/persondata'
import Persondatahome from '@/pages/persondata/children/persondatahome'

import Orderdetail from '@/pages/persondata/children/orderdetail'
import Travelorder from '@/pages/persondata/children/travelorder'
import Collection from '@/pages/persondata/children/collection'
import Travelcol from '@/pages/persondata/children/travelcol'
import Individual from '@/pages/persondata/children/individual'
import Invoice from '@/pages/persondata/children/invoice'
import Evaluate from '@/pages/persondata/children/evaluate'
import Complaint from '@/pages/persondata/children/complaint'
import Binding from '@/pages/persondata/children/binding'
import Modify from '@/pages/persondata/children/modify'

import Orderparticulars from '@/pages/persondata/children/orderparticulars'
import Orderparticularstravel from '@/pages/persondata/children/orderparticularstravel'
import Travel from '@/pages/travel/travel'
import TravelDetail from '@/pages/travelDetail/travelDetail'
import Tourism from '@/pages/tourism/tourism'
import TourismDetail from '@/pages/tourismDetail/tourismDetail'
import ConfirmOrder from '@/pages/confirmOrder/confirmOrder'
import PlaceOrder from '@/pages/placeOrder/placeOrder'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/test',
            name: 'Test',
            component: Test
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            name: 'Home',
            component: Home,
        },
        {
            path: '/charter',
            name: 'Charter',
            component: Charter,
            /*children: [{
                path: '/charterDetails/:id?:companyPic?:teamName',
                name: 'CharterDetails',
                component: CharterDetails
            }]*/
        },
        {
            path: '/charterDetails',
            name: 'CharterDetails',
            component: CharterDetails
        },
        {
            path: '/offer',
            name: 'Offer',
            component: Offer
        },
        {
            path: '/quotation',
            name: 'Quotation',
            component: Quotation
        },
        {
            path: '/information',
            name: 'Information',
            component: Information
        },
        {
            path: '/informationcharter',
            name: 'Informationcharter',
            component: Informationcharter
        },
        {
            path: '/informationDetails/:cidgid',
            name: 'InformationDetails',
            component: informationDetails
        },
        {
            path: '/join',
            name: 'Join',
            component: Join
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/persondata',
            name: 'Persondata',
            component: Persondata,
            redirect: 'persondatahome',
            children: [
                {
                    path: '/persondatahome',
                    name: 'Persondatahome',
                    component: Persondatahome
                },
                {
                    path: '/orderdetail',
                    name: 'Orderdetail',
                    component: Orderdetail
                },
                {
                    path: '/travelorder',
                    name: 'Travelorder',
                    component: Travelorder
                },
                {
                    path: '/collection',
                    name: 'Collection',
                    component: Collection
                },
                {
                    path: '/travelcol',
                    name: 'Travelcol',
                    component: Travelcol
                },
                {
                    path: '/individual',
                    name: 'Individual',
                    component: Individual
                },
                {
                    path: '/invoice',
                    name: 'Invoice',
                    component: Invoice
                },
                {
                    path: '/evaluate',
                    name: 'Evaluate',
                    component: Evaluate
                },
                {
                    path: '/complaint',
                    name: 'Complaint',
                    component: Complaint
                },
                {
                    path: '/binding',
                    name: 'Binding',
                    component: Binding
                },
                {
                    path: '/modify',
                    name: 'Modify',
                    component: Modify
                },
            ],
        },
        {
            path: '/orderparticulars',
            name: 'Orderparticulars',
            component: Orderparticulars
        },
        {
            path: '/orderparticularstravel',
            name: 'Orderparticularstravel',
            component: Orderparticularstravel
        },
        {
            path: '/helpcenter',
            name: 'HelpCenter',
            component: HelpCenter
        },
        {
            path: '/feedback',
            name: 'FeedBack',
            component: FeedBack
        },
        {
            path: '/customtrips',
            name: 'CustomTrips',
            component: CustomTrips
        },
        {
            path: '/travel',
            name: 'Travel',
            component: Travel
        },
        {
            path: '/travelDetail/:cidgid',
            name: 'TravelDetail',
            component: TravelDetail
        },
        {
            path: '/tourism',
            name: 'Tourism',
            component: Tourism
        },
        {
            path: '/tourismDetail',
            name: 'TourismDetail',
            component: TourismDetail
        },
        {
            path: '/confirmOrder',
            name: 'ConfirmOrder',
            component: ConfirmOrder
        },
        {
            path: '/placeOrder',
            name: 'PlaceOrder',
            component: PlaceOrder
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js